import { render, staticRenderFns } from "./EventPeople.vue?vue&type=template&id=9e50ce70"
import script from "./EventPeople.vue?vue&type=script&lang=js"
export * from "./EventPeople.vue?vue&type=script&lang=js"
import style0 from "./EventPeople.vue?vue&type=style&index=0&id=9e50ce70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports